module.exports = __webpack_public_path__ + "img/UCF-logo.e68e8241.png";